import { Box, Grid2, Typography } from "@mui/material";

import { useWhiteScreen } from "../../../../hooks/useWhiteScreen";
import { Container } from "../../../common/Container/Container";
import { Loading } from "../../../common/Loading/Loading";
import { NotFound } from "../../../common/NotFound/NotFound";
import { CourseAviationStory } from "./components/CourseAviationStory/CourseAviationStory";
import { CourseCheckoutButton } from "./components/CourseCheckoutButton/CourseCheckoutButton";
import { CourseInstructor } from "./components/CourseInstructor/CourseInstructor";
import { CourseLessons } from "./components/CourseLessons/CourseLessons";
import { CourseLocation } from "./components/CourseLocation/CourseLocation";
import { CoursePrerequisites } from "./components/CoursePrerequisites/CoursePrerequisites";
import { CourseRecommendedPace } from "./components/CourseRecommendedPace/CourseRecommendedPace";
import { CourseTrainingOverview } from "./components/CourseTrainingOverview/CourseTrainingOverview";
import {
	usePreviewCourse,
	usePreviewCourseInit,
} from "./hooks/usePreviewCourse";

import "./preview_course.scss";

export function PreviewCourse() {
	const { loading } = usePreviewCourseInit();
	const { course } = usePreviewCourse();
	useWhiteScreen();

	if (!loading && !course) {
		return <NotFound white text="Course not found" />;
	}

	if (loading) {
		return (
			<Container
				navbarOrkaProps={{ white: true }}
				className="preview-course-container">
				<div style={{ display: "flex", justifyContent: "center" }}>
					<Loading absolute={false} />
				</div>
			</Container>
		);
	}

	if (!course) {
		return null;
	}

	return (
		<Container
			navbarOrkaProps={{ white: true }}
			className="preview-course-container">
			<Grid2
				container
				columnSpacing={{
					xs: "0",
					sm: "0",
					md: "5vw",
					lg: "5vw",
					xl: "5vw",
				}}
				rowSpacing={{
					xs: "8px",
					sm: "8px",
					md: "16px",
					lg: "0",
					xl: "0",
				}}>
				<Grid2 size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 7 }}>
					<Typography className="normal-title black-label">
						{course.name}
					</Typography>
					<Typography>
						<Typography className="normal-text bold" component="span">
							{"Instructor: "}
						</Typography>
						<Typography
							component="a"
							className="normal-text black-text underline-on-hover-link"
							href="#instructor-info">
							{`${course.teacher?.firstName ?? ""} ${course.teacher?.lastName ?? ""}`.trim()}
						</Typography>
					</Typography>
				</Grid2>
				<Grid2 size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 5 }}>
					<CourseCheckoutButton />
				</Grid2>
				<Grid2 size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 7 }}>
					<CourseAviationStory />
					<Typography
						whiteSpace="break-spaces"
						marginTop={{
							xs: "16px",
							sm: "16px",
							md: "32px",
							lg: "32px",
							xl: "32px",
						}}
						textAlign="justify"
						className="normal-text">
						{course.description}
					</Typography>
					<div className="separator" />
					{course.location && <CourseLocation />}
					{course.location && <div className="separator" />}
					<CourseInstructor />
				</Grid2>
				<Grid2 size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 5 }}>
					<Box
						display={{
							xs: "unset",
							sm: "unset",
							md: "none",
							lg: "none",
							xl: "none",
						}}>
						<div className="separator" />
					</Box>
					<Box
						height={{ xs: "0", sm: "0", md: "32px", lg: "32px", xl: "32px" }}
					/>
					<CoursePrerequisites />
					<CourseTrainingOverview />
					<div className="separator" />
					<CourseRecommendedPace />
					<div className="separator" />
					<CourseLessons />
				</Grid2>
			</Grid2>
		</Container>
	);
}
